import { Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../Components/InnerLayout/UserInterface";
const TestPage = (params) => {
  return (
    <div className="no-sidebar row" id="content">
      <nav className="pro-sidebar-layout">
        <div className="pro-sidebar-header">
          <a href="#_" class="logo_image" title="GoGMGo"></a>
        </div>
        <ul className="middleMenu">
          <li className="finance">
            <a role={Button}>
              <i class="icon-sprite img_icon_finance"></i>
            </a>
          </li>
          <li className="orderInvoice">
            <a role={Button}>
              <i class="icon-sprite img_icon_orderInvoice"></i>
            </a>
          </li>
          <li className="labor">
            <a role={Button}>
              <i class="icon-sprite img_icon_labor"></i>
            </a>
          </li>
          <li className="menuEngineer">
            <a role={Button}>
              <i class="icon-sprite img_icon_menuEngineer"></i>
            </a>
          </li>
          <li className="inventory">
            <a role={Button}>
              <i class="icon-sprite img_icon_inventory"></i>
            </a>
          </li>
          <li className="onlife">
            <a role={Button}>
              <i class="icon-sprite img_icon_onlife"></i>
            </a>
          </li>
          <li className="analysticReporting">
            <a role={Button}>
              <i class="icon-sprite img_icon_reporting"></i>
            </a>
          </li>
        </ul>

        <ul className="lowerMenu">
          <li className="clipboard">
            <a role={Button}>
              <i class="icon-sprite img_icon_manager_log"></i>
            </a>
          </li>
          <li className="setting">
            <a role={Button}>
              <i class="icon-sprite img_icon_setting"></i>
            </a>
          </li>
        </ul>
      </nav>
      <div className="subMenus">
        <div class="innerMenus" id="menu1">
          <ul>
            <li class="pro-menu-item menu-title">
              <div class="pro-inner-item" tabindex="0" role="button">
                <span class="pro-icon-wrapper">
                  <span class="pro-icon">
                    <i class="menuEngineer-small"></i>
                  </span>
                </span>
                <span class="pro-item-content">Menu Engineer</span>
              </div>
            </li>
            <li class="pro-menu-item">
              <div class="pro-inner-item" tabindex="0" role="button">
                <span class="pro-item-content">Menu Items</span>
              </div>
            </li>
            <li class="pro-menu-item">
              <div class="pro-inner-item" tabindex="0" role="button">
                <span class="pro-item-content">Recipes</span>
              </div>
            </li>
            <li class="pro-menu-item">
              <div class="pro-inner-item" tabindex="0" role="button">
                <span class="pro-item-content">Ingredients</span>
              </div>
            </li>
            <li class="pro-menu-item">
              <div class="pro-inner-item" tabindex="0" role="button">
                <span class="pro-item-content">Menu Pricing</span>
              </div>
            </li>
            <li class="pro-menu-item">
              <div class="pro-inner-item" tabindex="0" role="button">
                <span class="pro-item-content">Promotions</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default TestPage;
